import { Entity } from "~/utils";

export type Meaple = Entity & {
  owner?: string;
};

export const Meaple = {
  new(id: string, owner: string | undefined): Meaple {
    return {
      id,
      owner,
    };
  },
  isMentat(meaple: Meaple): boolean {
    return !meaple.owner;
  },
};
